import React from 'react'
import ListPageTemplate from './templates/ListPageTemplate'
import { FOCUS } from '../data/focus'
import LOG from '../logging/Logger'

export default props => {
  LOG.debug('Render: NotesPage')

  return <ListPageTemplate list={FOCUS.NOTES.id} {...props} />
}
